import { create } from 'zustand'

export interface NavigationState {
    isMenuOpen: boolean
    setIsMenuOpen: (value: boolean) => void
    isMenuDisabled: boolean
    setIsMenuDisabled: (value: boolean) => void
    isHomeDisabled: boolean
    setIsHomeDisabled: (value: boolean) => void
    hasBackgroundMusic: boolean
    setHasBackgroundMusic: (value: boolean) => void
    isMusicButtonDisabled: boolean
    setIsMusicButtonDisabled: (value: boolean) => void
}

export const useNavigationStore = create<NavigationState>((set) => ({
    isMenuOpen: false,
    setIsMenuOpen: (isMenuOpen) => set({ isMenuOpen }),
    isMenuDisabled: false,
    setIsMenuDisabled: (isMenuDisabled) => set({ isMenuDisabled }),
    isHomeDisabled: false,
    setIsHomeDisabled: (isHomeDisabled) => set({ isHomeDisabled }),
    hasBackgroundMusic: false,
    setHasBackgroundMusic: (hasBackgroundMusic) => set({ hasBackgroundMusic }),
    isMusicButtonDisabled: false,
    setIsMusicButtonDisabled: (isMusicButtonDisabled) => set({ isMusicButtonDisabled }),
}))
